import { useTranslation } from "react-i18next";
import { createFileRoute } from "@tanstack/react-router";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

export const Route = createFileRoute("/_authenticated/language-settings")({
  component: Settings,
});

function Settings() {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto py-6">
      <div className="space-y-4">
        <h2 className="text-3xl font-bold tracking-tight">{t("Select Language")}</h2>

        <div className="w-[200px]">
          <LanguageSwitcher className="h-10 w-full" />
        </div>
      </div>
    </div>
  );
}
